var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPatients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.765 9.645a7.067 7.067 0 0 1-7.06 7.06 7.067 7.067 0 0 1-7.06-7.06 7.067 7.067 0 0 1 7.06-7.06 7.067 7.067 0 0 1 7.06 7.06zm1.765 0c0-4.865-3.959-8.824-8.825-8.824-4.865 0-8.824 3.959-8.824 8.824 0 4.866 3.959 8.825 8.824 8.825 4.866 0 8.825-3.959 8.825-8.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.293 37.884H1.703A.883.883 0 0 1 .822 37v-7.06C.821 25.564 4.385 22 8.763 22h15.884c2.166 0 4.25.89 5.724 2.446a.882.882 0 1 1-1.281 1.214 6.14 6.14 0 0 0-4.443-1.895H8.763a6.184 6.184 0 0 0-6.177 6.177v6.177h9.707a.883.883 0 0 1 0 1.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.412 43.178a.88.88 0 0 1-.789-.487l-3.286-6.572h-4.75a.883.883 0 0 1 0-1.765h5.295c.334 0 .64.189.79.487l2.678 5.358 4.545-10.605a.884.884 0 0 1 .785-.535c.341.013.662.18.816.487l5.05 10.103h4.75a.883.883 0 0 1 0 1.764h-5.294a.884.884 0 0 1-.79-.487l-4.443-8.888-4.545 10.606a.884.884 0 0 1-.785.534h-.027z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatients);
export default __webpack_public_path__ + "static/media/icon-patients.3df7b3b03cf6a66165f8962881244d60.svg";
export { ForwardRef as ReactComponent };